import type {
  BulkAccessRequest,
  BulkAccessResult,
} from '~/features/access-control/types/AccessControl';

import { applyDocumentBulkAccessForRequest } from '~/features/access-control/mocks/accessControlMockStore';
import { withAccessControlMockFallback } from '~/features/access-control/mocks/withAccessControlMockFallback';
import { ServiceRequestConfig } from '~/services/createService';
import { pilot } from '~/services/serviceInstances';

import type { ServerBulkAccessResult } from './bulkAccessMapper';

import {
  mapBulkAccessRequest,
  mapBulkAccessResultResponse,
} from './bulkAccessMapper';

export const bulkUpdateAccess = async (
  request: BulkAccessRequest,
  options: ServiceRequestConfig = {},
): Promise<BulkAccessResult> => {
  return withAccessControlMockFallback(
    async () => {
      const serverResponse = await pilot.post<ServerBulkAccessResult>(
        '/access/bulk/',
        mapBulkAccessRequest(request),
        options,
      );

      return mapBulkAccessResultResponse(serverResponse);
    },
    () => applyDocumentBulkAccessForRequest(request),
  );
};
